import React, { FC, useState, useEffect } from 'react'
import Isvg from 'react-inlinesvg'
import _ from "lodash"
// Components
import CreateSnapshotForm from 'components/snapshots/create-snapshot-form'
import Popover from 'components/popover/popover'
import { WithTip } from 'components/tooltip/with-tip'
// Data
import keyService, * as chord from "data/key"
import snapshotService from "data/snapshots"
// Styles
import { HeaderIcon_s } from 'components/wrapper/header/header-styles'
import { ShortcutHint_s } from 'styles/shortcut-styles'
// Icons
import { SnapshotIcon } from 'images/icons/header/'

interface CreateSnapshotProps {
  position?: string
  type: 'folder' | 'property'
}

const CreateSnapshot: FC<CreateSnapshotProps> = (props) => {
  const [showPopover, togglePopover] = useState<boolean>(false);
  const [hintsVisible, setHintsVisible] = useState<boolean>(false)
  const isFolder = props.type == 'folder'

  const [showAssetWarning, setShowAssetWarming] = useState(false)

  useEffect(() => {
    if (!showPopover) return setShowAssetWarming(false)
    snapshotService.checkAssets(isFolder ? 'folder' : 'property').then(isAsset => {
      setShowAssetWarming(isAsset)
    })
  }, [showPopover])

  useEffect(() => {
    keyService.stream().subscribe(k => {
      switch(true) {
        case k.chord === chord.CTRL_ALT_S && k.down === true:
          togglePopover(true)
          break
        case k.chord === chord.CTRL_ALT && k.down === true:
          setHintsVisible(true)
          break
        case k.chord === chord.CTRL_ALT && k.down === false:
          setHintsVisible(false)
          break
      }
    })
  }, [])

  const CreateSnapshotOverlay = (
    <Popover
      position={props.position}
      left={15}
      show={showPopover}
      target='createSnapshotIcon'
      title={`Create a ${isFolder ? 'Folder' : 'Property'} Snapshot`}
      toggleShow={togglePopover}
      width={350}
    >
      <CreateSnapshotForm togglePopover={togglePopover} showAssetWarning={showAssetWarning} type={props.type} />
    </Popover>
  );

  return (
    <HeaderIcon_s>
      <WithTip position="bottom">
        <span>{`Create Snapshot of Current ${isFolder ? 'Folder' : 'Property'}`}</span>
        <a onClick={()=>togglePopover(!showPopover)}>
          <Isvg src={SnapshotIcon} id="createSnapshotIcon" />
          { hintsVisible && <ShortcutHint_s className="header-hint" visible={hintsVisible}>S</ShortcutHint_s> }
        </a>
      </WithTip>
      { CreateSnapshotOverlay }
    </HeaderIcon_s>
  )
}

export default CreateSnapshot